// // src/pages/MyCoursesPage.jsx
// "use client";

// import React, { useEffect, useMemo } from "react";
// import { useNavigate } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   useGetCoursesQuery,
//   useGetCourseProgressQuery,
// } from "@/features/api/courseApi";
// import { useGetOrdersQuery } from "@/features/api/orderApi";
// import { Button } from "@/components/ui/button";
// import { Card, CardContent, CardHeader } from "@/components/ui/card";
// import { Skeleton } from "@/components/ui/skeleton";
// import { Progress } from "@/components/ui/progress";
// import { toast } from "sonner";
// import { BookOpen, Video } from "lucide-react";

// const MyCoursesPage = () => {
//   const navigate = useNavigate();
//   const user = useSelector((state) => state.auth.user);

//   /* ------------------------------------------
//      Redirect if not logged in
//   ------------------------------------------ */
//   useEffect(() => {
//     if (!user) navigate("/login");
//   }, [user, navigate]);

//   /* ------------------------------------------
//      Fetch SUCCESS Orders (Paid + Free)
//   ------------------------------------------ */
//   const {
//     data: ordersData,
//     isLoading: ordersLoading,
//     isError: ordersError,
//     refetch: refetchOrders,
//   } = useGetOrdersQuery(
//     { limit: 100 },
//     { skip: !user }
//   );

//   /* ------------------------------------------
//      Fetch All Courses
//   ------------------------------------------ */
//   const {
//     data: coursesData,
//     isLoading: coursesLoading,
//   } = useGetCoursesQuery(undefined, { skip: !user });

//   const allCourses = coursesData?.courses || [];

//   /* ------------------------------------------
//      Extract Purchased Course IDs
//   ------------------------------------------ */
//   const purchasedCourseIds = useMemo(() => {
//     if (!ordersData?.data?.length) return [];

//     return [
//       ...new Set(
//         ordersData.data
//           .filter((order) => order.status === "SUCCESS")
//           .map((order) => order.courseId)
//       ),
//     ];
//   }, [ordersData]);

//   /* ------------------------------------------
//      Filter Purchased Courses
//   ------------------------------------------ */
//   const purchasedCourses = useMemo(() => {
//     if (!purchasedCourseIds.length || !allCourses.length) return [];

//     return allCourses.filter((course) =>
//       purchasedCourseIds.includes(course._id)
//     );
//   }, [purchasedCourseIds, allCourses]);

//   /* ------------------------------------------
//      Error Handling
//   ------------------------------------------ */
//   useEffect(() => {
//     if (ordersError) {
//       toast.error("Failed to load your purchased courses.");
//     }
//   }, [ordersError]);

//   /* ------------------------------------------
//      Skeleton Loader
//   ------------------------------------------ */
//   const CourseSkeleton = () => (
//     <div className="w-full animate-pulse space-y-3">
//       <Skeleton className="h-40 w-full rounded-lg" />
//       <Skeleton className="h-4 w-3/4 rounded" />
//       <Skeleton className="h-4 w-1/2 rounded" />
//       <Skeleton className="h-10 w-full rounded" />
//     </div>
//   );

//   /* ------------------------------------------
//      UI
//   ------------------------------------------ */
//   return (
//     <div className="bg-gray-50 min-h-screen">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
//         <h1 className="text-3xl font-bold text-center mb-10">
//           🎓 My Courses
//         </h1>

//         {ordersLoading || coursesLoading ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {Array.from({ length: 6 }).map((_, i) => (
//               <CourseSkeleton key={i} />
//             ))}
//           </div>
//         ) : ordersError ? (
//           <div className="text-center text-red-600 text-lg font-medium">
//             Failed to load your courses.
//             <Button onClick={refetchOrders} className="ml-2">
//               Retry
//             </Button>
//           </div>
//         ) : purchasedCourses.length === 0 ? (
//           <div className="text-center text-gray-500 text-lg font-medium">
//             📭 You haven’t enrolled in any courses yet.
//           </div>
//         ) : (
//           <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
//             {purchasedCourses.map((course) => (
//               <CourseCard
//                 key={course._id}
//                 course={course}
//                 navigate={navigate}
//               />
//             ))}
//           </div>
//         )}
//       </div>
//     </div>
//   );
// };

// /* =====================================================
//    Separate CourseCard Component (Correct Progress Fetch)
// ===================================================== */

// const CourseCard = ({ course, navigate }) => {
//   const {
//     data: progressData,
//     isLoading: progressLoading,
//   } = useGetCourseProgressQuery(course._id);

//   const percentage = progressData?.percentage || 0;
//   const attempts = progressData?.attempts || [];

// const hasAttempt =
//   (progressData?.attempts || []).length > 0 ||
//   percentage > 0;

//   /* ================= BUTTON TEXT ================= */
//   let buttonText = "Start Now";
//   if (progressLoading) buttonText = "Loading...";
//   else if (percentage === 100) buttonText = "Completed";
//   else if (percentage > 0) buttonText = "Continue";

//   return (
//     <Card className="overflow-hidden hover:shadow-lg transition-all flex flex-col group">

//       {/* IMAGE */}
//       {course.featuredImage ? (
//         <img
//           src={
//             typeof course.featuredImage === "string"
//               ? course.featuredImage
//               : course.featuredImage?.url || ""
//           }
//           alt={course.altText || course.title}
//           className="w-full h-40 object-cover group-hover:scale-105 transition"
//         />
//       ) : (
//         <div className="w-full h-40 bg-muted flex items-center justify-center">
//           <Video className="h-10 w-10 text-muted-foreground" />
//         </div>
//       )}

//       {/* HEADER */}
//       <CardHeader className="p-4">
//         <h2 className="font-semibold line-clamp-2 text-lg">
//           {course.title}
//         </h2>
//         <p className="text-sm text-muted-foreground mt-1">
//           {course.instructorName || "Instructor"}
//         </p>
//       </CardHeader>

//       {/* CONTENT */}
//       <CardContent className="p-4 flex flex-col gap-3 flex-grow">

//         {/* PROGRESS */}
//         {progressLoading ? (
//           <Skeleton className="h-4 w-1/2" />
//         ) : (
//           <div className="space-y-1">
//             <div className="flex justify-between text-sm">
//               <span>Progress</span>
//               <span>{percentage}%</span>
//             </div>
//             <Progress value={percentage} />
//           </div>
//         )}

//         {/* ACTION BUTTONS */}
//         <div className="flex flex-col gap-2 mt-auto">

//           {/* LEARN BUTTON */}
//           <Button
//             className="w-full"
//             onClick={() =>
//               navigate(`/courses/${course.slug}/learn`)
//             }
//             disabled={progressLoading}
//           >
//             <BookOpen className="mr-2 h-4 w-4" />
//             {buttonText}
//           </Button>

//           {/* RESULT BUTTON (ONLY IF ATTEMPT EXISTS) */}
//           {hasAttempt && (
//             <Button
//               variant="outline"
//               className="w-full border-green-600 text-green-600 hover:bg-green-50"
//               onClick={() =>
//                 navigate(`/dashboard/courses/${course.slug}/result`)
//               }
//             >
//               📊 View Result
//             </Button>
//           )}
//         </div>
//       </CardContent>
//     </Card>
//   );
// };

// export default MyCoursesPage;





import React, { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  useGetCoursesQuery,
  useGetCourseProgressQuery,
} from "@/features/api/courseApi";
import { useGetOrdersQuery } from "@/features/api/orderApi";

import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import { Progress } from "@/components/ui/progress";
import { toast } from "sonner";
import { BookOpen, Video, Trophy } from "lucide-react";

const MyCoursesPage = () => {
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  /* Redirect if not logged in */
  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  /* Fetch Orders (to check purchased courses) */
  const {
    data: ordersData,
    isLoading: ordersLoading,
    isError: ordersError,
    refetch: refetchOrders,
  } = useGetOrdersQuery({ limit: 100 }, { skip: !user });

  /* Fetch All Courses */
  const { data: coursesData, isLoading: coursesLoading } = useGetCoursesQuery(
    undefined,
    { skip: !user }
  );

  const allCourses = coursesData?.courses || [];

  /* Extract Purchased Course IDs */
  const purchasedCourseIds = useMemo(() => {
    if (!ordersData?.data?.length) return [];
    return [
      ...new Set(
        ordersData.data
          .filter((order) => order.status === "SUCCESS")
          .map((order) => order.courseId)
      ),
    ];
  }, [ordersData]);

  /* Filter Purchased Courses */
  const purchasedCourses = useMemo(() => {
    if (!purchasedCourseIds.length || !allCourses.length) return [];
    return allCourses.filter((course) =>
      purchasedCourseIds.includes(course._id)
    );
  }, [purchasedCourseIds, allCourses]);

  /* Error Toast */
  useEffect(() => {
    if (ordersError) {
      toast.error("Failed to load your purchased courses. Please try again.");
    }
  }, [ordersError]);

  if (ordersLoading || coursesLoading) {
    return (
      <div className="bg-gray-50 min-h-screen py-10">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-3xl font-bold text-center mb-10">🎓 My Courses</h1>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {Array.from({ length: 8 }).map((_, i) => (
              <CourseSkeleton key={i} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-center mb-10">🎓 My Courses</h1>

        {ordersError ? (
          <div className="text-center py-20">
            <p className="text-red-600 text-lg mb-4">
              Failed to load your courses
            </p>
            <Button onClick={refetchOrders}>Retry</Button>
          </div>
        ) : purchasedCourses.length === 0 ? (
          <div className="text-center py-20">
            <div className="mx-auto w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mb-6">
              <BookOpen className="h-10 w-10 text-gray-400" />
            </div>
            <h3 className="text-xl font-medium text-gray-600 mb-2">
              No courses yet
            </h3>
            <p className="text-gray-500 mb-6">
              You haven’t enrolled in any courses yet.
            </p>
            <Button onClick={() => navigate("/courses")}>
              Browse Available Courses
            </Button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {purchasedCourses.map((course) => (
              <CourseCard key={course._id} course={course} navigate={navigate} />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

/* ====================== Course Card Component ====================== */
const CourseCard = ({ course, navigate }) => {
  const { data: progressData, isLoading: progressLoading } =
    useGetCourseProgressQuery(course._id, {
      skip: !course._id,
    });

  const percentage = progressData?.percentage || 0;
  const isCompleted = percentage === 100;

  const buttonText = progressLoading
    ? "Loading..."
    : isCompleted
    ? "Completed ✓"
    : percentage > 0
    ? "Continue Learning"
    : "Start Course";

  return (
    <Card className="overflow-hidden hover:shadow-xl transition-all duration-300 flex flex-col group">
      {/* Course Image */}
      {course.featuredImage ? (
        <img
          src={
            typeof course.featuredImage === "string"
              ? course.featuredImage
              : course.featuredImage?.url || ""
          }
          alt={course.title}
          className="w-full h-44 object-cover group-hover:scale-105 transition-transform duration-300"
        />
      ) : (
        <div className="w-full h-44 bg-gradient-to-br from-gray-100 to-gray-200 flex items-center justify-center">
          <Video className="h-12 w-12 text-gray-400" />
        </div>
      )}

      <CardHeader className="p-4 pb-3">
        <h3 className="font-semibold text-lg leading-tight line-clamp-2">
          {course.title}
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          {course.instructorName || "Instructor"}
        </p>
      </CardHeader>

      <CardContent className="p-4 pt-0 flex-1 flex flex-col">
        {/* Progress */}
        <div className="mb-4">
          {progressLoading ? (
            <Skeleton className="h-2.5 w-full rounded" />
          ) : (
            <div className="space-y-2">
              <div className="flex justify-between text-sm text-gray-600">
                <span>Progress</span>
                <span className="font-medium">{percentage}%</span>
              </div>
              <Progress value={percentage} className="h-2.5" />
            </div>
          )}
        </div>

        {/* Action Buttons */}
        <div className="mt-auto flex flex-col gap-2">
          <Button
            className="w-full"
            onClick={() => navigate(`/courses/${course.slug}/learn`)}
            disabled={progressLoading}
          >
            <BookOpen className="mr-2 h-4 w-4" />
            {buttonText}
          </Button>

          {percentage > 0 && (
            <Button
              variant="outline"
              className="w-full"
              onClick={() =>
                navigate(`/dashboard/courses/${course.slug}/result`)
              }
            >
              <Trophy className="mr-2 h-4 w-4" />
              View Result
            </Button>
          )}
        </div>
      </CardContent>
    </Card>
  );
};

/* Skeleton Loader */
const CourseSkeleton = () => (
  <div className="bg-white rounded-xl overflow-hidden animate-pulse">
    <Skeleton className="h-44 w-full" />
    <div className="p-4">
      <Skeleton className="h-5 w-4/5 mb-2" />
      <Skeleton className="h-4 w-3/5 mb-4" />
      <Skeleton className="h-2.5 w-full mb-4" />
      <Skeleton className="h-10 w-full" />
    </div>
  </div>
);

export default MyCoursesPage;